export const configKeys = {
  detail: (configType: string) => [configType]
};
